import { SortConfig } from '../ui/components/table/table.types'

const sortData = <A extends Record<string, any>>(items: A[], config: SortConfig): A[] => {
  const sortedItems = [...items]

  switch (config.method) {
    case 'alphabetical':
      sortedItems.sort((a, b) => {
        if (a[config.key] < b[config.key]) {
          return config.direction === 'ascending' ? -1 : 1
        }
        if (a[config.key] > b[config.key]) {
          return config.direction === 'ascending' ? 1 : -1
        }
        return 0
      })
      break
    case 'date':
      try {
        sortedItems.sort((a, b) => {
          const date1 = new Date(a[config.key]).getTime()
          const date2 = new Date(b[config.key]).getTime()
          if (Number.isNaN(date1) || Number.isNaN(date2)) throw new Error('Invalid Date')

          if (date1 < date2) return config.direction === 'ascending' ? -1 : 1
          if (date1 > date2) return config.direction === 'ascending' ? 1 : -1

          return 0
        })
      } catch (err) {
        return items
      }
      break
    case 'number':
      try {
        sortedItems.sort((a, b) => {
          const number1 = typeof a[config.key] === 'number' ? a[config.key] : Number(a[config.key])
          const number2 = typeof b[config.key] === 'number' ? b[config.key] : Number(b[config.key])

          if (Number.isNaN(number1) || Number.isNaN(number2)) throw new Error('Invalid Number')
          if (number1 < number2) {
            return config.direction === 'ascending' ? -1 : 1
          }
          if (number1 > number2) {
            return config.direction === 'ascending' ? 1 : -1
          }
          return 0
        })
      } catch (err) {
        return items
      }
      break
    default:
      return items
  }
  return sortedItems
}

export default sortData
